/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { dashboardsCreate } from "../funcs/dashboardsCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Dashboard } from "../models/components/dashboard.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateDashboardRequest,
  CreateDashboardSecurity,
} from "../models/operations/createdashboard.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateDashboardMutationVariables = {
  request: CreateDashboardRequest;
  security?: CreateDashboardSecurity | undefined;
  options?: RequestOptions;
};

export type CreateDashboardMutationData = Dashboard;

export type CreateDashboardMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createDashboard dashboards
 *
 * @remarks
 * Make an empty dashboard. Any member of the project can.
 */
export function useCreateDashboardMutation(
  options?: MutationHookOptions<
    CreateDashboardMutationData,
    CreateDashboardMutationError,
    CreateDashboardMutationVariables
  >,
): UseMutationResult<
  CreateDashboardMutationData,
  CreateDashboardMutationError,
  CreateDashboardMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateDashboardMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateDashboard(): MutationKey {
  return ["@gram/client", "dashboards", "create"];
}

export function buildCreateDashboardMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateDashboardMutationVariables,
  ) => Promise<CreateDashboardMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateDashboard(),
    mutationFn: function createDashboardMutationFn({
      request,
      security,
      options,
    }): Promise<CreateDashboardMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(dashboardsCreate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
